@defer () {
<div class="flex flex-col full-grow-no-shrink-no-basis">
  <div class="m-l-auto">
    <button mat-icon-button [matMenuTriggerFor]="rootMenu">
      <i class="fa-regular fa-ellipsis"></i>
    </button>
    <mat-menu #rootMenu="matMenu" [overlapTrigger]="false">
      <button mat-menu-item (click)="selectRootGroup(pageModel.id)">
        <span>Select Group</span>
      </button>
    </mat-menu>
  </div>

  <div class="node-helipad full-grow-no-shrink-no-basis" cdkDropList [cdkDropListDisabled]="true"
    (cdkDropListDropped)="drop($event)" [cdkDropListSortingDisabled]="true" [cdkDropListSortPredicate]="canSort()"
    [cdkDropListAutoScrollDisabled]="true"
    [ngClass]="{'gridster-item-group-active': pageModel.id === eliteFormDesignService.activeCanvasId()}">

    <gridster [options]="allOptions[pageModel.id]" [ngStyle]="{'min-height': allGroupHeight[pageModel.id]+'px'}">
      @for (item of dashboardByGroup[pageModel.id]; track item.id) {
      <gridster-item [item]="item" [ngClass]="{
          'gridster-item-group-active': item.id === eliteFormDesignService.activeCanvasId(),
          'gridster-item-group': item.dataType === 'Group'
        }">
        <ng-container [ngTemplateOutlet]="itemContent" [ngTemplateOutletContext]="{ $implicit: item }">
        </ng-container>
      </gridster-item>
      }
    </gridster>
  </div>
</div>

<ng-template #itemContent let-item>
  <div class="gridster-item-container" [class.gridster-group-item-content]="item.dataType === 'Group'">

    <div class="design-card-header">
      <div class="design-card-drag-handle">
        <i class="fa-solid fa-grip-vertical"></i>
      </div>

      <div class="design-card-info">
        <div class="design-card-title">
          <ng-container [ngSwitch]="item.dataType">
            <div *ngSwitchCase="'Title'" class="rich-text-title">
              <particle-dynamic-html [content]="item.title"></particle-dynamic-html>
            </div>
            <div *ngSwitchCase="'Description'" class="description-preview">
              <particle-dynamic-tooltip-container [openOption]="'hover'" [htmlElement]="item.title" [theme]="'dark'">
                <span><i class="fa-regular fa-eye"></i> View Description</span>
              </particle-dynamic-tooltip-container>
            </div>
            <div *ngSwitchDefault class="field-label" [innerHTML]="item.title"></div>
          </ng-container>

          <span *ngIf="item.isMandatory" class="mandatory-star">*</span>
          <span *ngIf="item.instruction" class="instruction-text text-muted text-small ml-2">-
            {{item.instruction}}</span>
        </div>

        <div class="design-card-meta">
          <!-- Show Tags -->
          <span class="tag">{{item.dataType}}</span>
          <span class="tag" *ngIf="item.metaData['IsMultiResponseField']">Multi-Response</span>
          <span class="tag" *ngIf="item.metaData['IsTransposeGroup']">Transpose</span>
        </div>
      </div>

      <div class="design-card-actions">
        <button class="action-btn" [matTooltip]="'Copy Field Key'" (click)="copyValue(item, $event)">
          <i class="fa-solid fa-copy"></i>
        </button>
        <button class="action-btn" [matTooltip]="'Move Field'" (click)="moveQuestionBetweenGroup(item)">
          <i class="fa-regular fa-arrow-turn-down-right"></i>
        </button>
        <ng-container *ngIf="item.dataType === 'Group'">
          <button class="action-btn" (click)="selectGroup(item)" [matTooltip]="'Select Group'">
            <i class="fa-regular fa-object-group"></i>
          </button>
        </ng-container>

        <button class="action-btn" (click)="editField(item)" [matTooltip]="'Edit Field'">
          <i class="fa-solid fa-pencil"></i>
        </button>

        <button class="action-btn" (click)="deleteField(item)" [matTooltip]="'Delete Field'">
          <i class="fa-solid fa-trash"></i>
        </button>
      </div>
    </div>

    <div class="design-card-body" *ngIf="item.dataType === 'Group'">
      <gridster [options]="allOptions[item.id]" [ngStyle]="{'min-height': allGroupHeight[item.id]+'px'}">
        @for (subItem of dashboardByGroup[item.metaData['ChildPageModelId']]; track subItem.id) {
        <gridster-item [item]="subItem" [ngClass]="{
                        'gridster-item-group-active': subItem.id === eliteFormDesignService.activeCanvasId(),
                        'gridster-item-group': subItem.dataType === 'Group'
                      }">
          <ng-container [ngTemplateOutlet]="itemContent" [ngTemplateOutletContext]="{ $implicit: subItem }">
          </ng-container>
        </gridster-item>
        }
      </gridster>
    </div>

  </div>
</ng-template>
}
